import basicController from "servicestack/basic.controller.properties";
import orderConfig from "emun.order/order.config";
import labels from "emun.order/_labels";

export default class PartsOrderDetailsHeaderController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.orderConfig = orderConfig;
    $ctrl.labels = labels;
  }
}